module.exports = __webpack_public_path__ + "static/img/zhongzhongka1.01d763e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhongzhongka1.png
// module id = fLLM
// module chunks = 16